import React from "react";
import "./styles.scss";

import { Divider } from "@mui/material";

const ShippingBilling = ({ data }) => {
  return (
    <div className="shipping-billing-container">
      <h3>Billing & Shipping</h3>
      <Divider variant="middle" component="div" />
      <div className="payment-section">
        <label>Payment method</label>
        <div className="method">
          {data?.payment_method?.payment_icon && (
            <div>
              <img src={data?.payment_method?.payment_icon} alt="" />
            </div>
          )}
          {data?.payment_method?.card_ends_in && (
            <div>
              <p>Ends in {data?.payment_method?.card_ends_in}</p>
              <p>Expires {data?.payment_method?.card_exp_year}</p>
            </div>
          )}
        </div>
      </div>

      <div className="address-section">
        <div className="content">
          <label>Shipping to </label>
          <div>
            <p>
              <span>{data?.shipping_details?.shipping_first_name}</span>{" "}
              <span>{data?.shipping_details?.shipping_last_name}</span>
            </p>
            <p>
              <span>{data?.shipping_details?.shipping_address_1}</span>{" "}
              <span>{data?.shipping_details?.shipping_address_2}</span>
            </p>
            <p>
              <span>{data?.shipping_details?.shipping_city}</span>,{" "}
              <span>{data?.shipping_details?.shipping_country}</span>{" "}
              <span>{data?.shipping_details?.shipping_state}</span>{" "}
              <span>{data?.shipping_details?.shipping_postcode}</span>
            </p>
          </div>
        </div>
        <div className="content">
          <label>Billing to </label>
          <div>
            <p>
              <span>{data?.billing_details?.billing_first_name}</span>{" "}
              <span>{data?.billing_details?.billing_last_name}</span>
            </p>
            <p>
              <span>{data?.billing_details?.billing_address_1}</span>{" "}
              <span>{data?.billing_details?.billing_address_2}</span>
            </p>
            <p>
              <span>{data?.billing_details?.billing_city}</span>,{" "}
              <span>{data?.billing_details?.billing_country}</span>{" "}
              <span>{data?.billing_details?.billing_state}</span>{" "}
              <span>{data?.billing_details?.billing_postcode}</span>
            </p>
          </div>
        </div>
        <div className="content">
          <label>Email address </label>
          <div>
            <p>{data?.email_address}</p>
          </div>
        </div>
        <div className="content">
          <label>Phone number </label>
          <div>
            <p>{data?.phone_number}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingBilling;
